// IE 2026 09 20 / ODOO-5800 (Igor: «на скрине3 [грид Conditional format] добавить колонку "selector", по которой показывать новый чипс-условного-оформления;
// по функционалу схожий с чипсом-метрик»): чистая логика чипса условного оформления (CHIP-Format) — без Vue и DOM.
// Контракт бэка ie-dm7 (be-ie 8c7179816, на запрос с client.metric_selector): словарь attrGrid.format_rules = [{id: <row_id правила>, title, css, style, order,
// rows, cells, fields, row, measure}] — только правила с selector = true (порядок — как в гриде правил); отметки строк dataItem._DLRow.formats = [row_id, …]
// (+ _DLRow.format_cells = {row_id: n}); задания оформления несут rule_id (= row_id правила) — по нему фронт знает, какое правило ОКРАСИЛО ячейку.
// Чипс: {segment: 'CHIP-Format', doc: {rules: [row_id, …]}, showAllLines, showOtherFormats}; глобального (в шапке стола) варианта нет — правила свои у виджета
export function formatChip_ids(doc) { return Array.isArray(doc?.rules) ? doc.rules.map(x => String(x || '')).filter(Boolean) : [] }
export function formatChip_isEmpty(doc) { return !formatChip_ids(doc).length }
export function formatChip_copy(doc) { return { rules: [...new Set(formatChip_ids(doc))] } }
export function formatChip_sig(doc) { return JSON.stringify([...new Set(formatChip_ids(doc))].sort()) }
// правило id выбрано чипсом
export function formatChip_has(doc, id) { return !!id && formatChip_ids(doc).includes(String(id)) }
// строка с отметкой выбранного правила
export function formatChip_matchRow(dataItem, doc) {
    const marks = dataItem?._DLRow?.formats
    if (!Array.isArray(marks) || !marks.length) return false
    const ids = formatChip_ids(doc)
    return marks.some(m => ids.includes(m))
}
// выбранные правила в порядке словаря; правило, которого в словаре уже нет (Selector сняли, правило удалили), идёт в хвост с known = false
export function formatChip_parts(doc, format_rules) {
    const ids = [...new Set(formatChip_ids(doc))], out = []
    for (const e of format_rules || []) if (e && ids.includes(e.id)) out.push({ id: e.id, title: e.title || e.id, css: e.css || '', style: e.style || '', rows: e.rows, cells: e.cells, known: true })
    for (const id of ids) if (!out.some(p => p.id === id)) out.push({ id, title: id, css: '', style: '', known: false })
    return out
}
export function formatChip_titleParts(doc, format_rules, max = 3) {
    const parts = formatChip_parts(doc, format_rules)
    return { shown: parts.slice(0, max).map(p => p.title), more: Math.max(0, parts.length - max) }
}
export function formatChip_text(doc, format_rules) { return formatChip_parts(doc, format_rules).map(p => p.title).join(', ') }
// переключение правила: exclusive (щелчок по названию / Alt) — оставить только его, как в форме чипса метрик; возвращает НОВЫЙ doc
export function formatChip_toggle(doc, id, exclusive = false) {
    const cur = formatChip_copy(doc), key = String(id || '')
    if (!key) return cur
    const has = cur.rules.includes(key)
    if (exclusive) return { rules: [key] }
    return { rules: has ? cur.rules.filter(x => x !== key) : [...cur.rules, key] }
}
// IE 2026 09 20 / ODOO-5800 (Igor 20.09: «при вкл селектора на строке условного оформления я ожидал, что появится чипс условного оформления над основной таблицей»;
// «чекбокс в строках усл. форматирования формы ячейки … при его вкл появится чипс»): заявка на изменение отбора чипса извне — из грида правил (Selector) и из
// формы ячейки (флажок правила). on — добавить ids, иначе убрать; solo — оставить только ids. Правило, которого ещё нет в словаре dictIds (бэк вернёт его после
// перечитывания данных), в отбор не идёт, а ждёт в pending. → { doc: новый отбор, pending: [ids, ждущие словаря] }
export function formatChip_request(doc, dictIds, ids, on, solo = false) {
    const known = new Set((dictIds || []).map(x => String(x || ''))), cur = [...new Set(formatChip_ids(doc))]
    const want = [...new Set((ids || []).map(x => String(x || '')).filter(Boolean))]
    if (!on) return { doc: { rules: solo ? [] : cur.filter(x => !want.includes(x)) }, pending: [] }
    return { doc: { rules: [...new Set([...(solo ? [] : cur), ...want.filter(x => known.has(x))])] }, pending: want.filter(x => !known.has(x)) }
}
// пришёл словарь: ждавшие правила, которые в нём есть, — в отбор. → { doc, added: [ids] }
export function formatChip_pendingApply(doc, dictIds, pendingIds) {
    const known = new Set((dictIds || []).map(x => String(x || '')))
    const added = [...new Set((pendingIds || []).map(x => String(x || '')).filter(x => x && known.has(x)))]
    return { doc: { rules: [...new Set([...formatChip_ids(doc), ...added])] }, added }
}
// список выбора формы: поиск по названию (все слова), порядок словаря
export function formatChip_items(doc, format_rules, text) {
    const terms = String(text || '').toLowerCase().split(/\s+/).filter(Boolean)
    const ids = formatChip_ids(doc)
    return (format_rules || []).filter(e => e && e.id && (!terms.length || terms.every(t => String(e.title || '').toLowerCase().includes(t))))
        .map(e => ({ id: e.id, title: e.title || e.id, css: e.css || '', style: e.style || '', rows: e.rows, cells: e.cells, on: ids.includes(e.id) }))
}
// «Show other formatting» снят: оформление задания остаётся, только если его правило выбрано чипсом (задание без rule_id — прочее оформление)
export function formatChip_keepsTask(task, doc) { return !!task && !!task.rule_id && formatChip_has(doc, task.rule_id) }
// история отборов (localStorage): свежие первыми, без повторов, не длиннее max
export function formatChip_histRead(storage, key) { try { const v = JSON.parse(storage.getItem(key) || '[]'); return Array.isArray(v) ? v.filter(h => h && h.doc && h.sig) : [] } catch (e) { return [] } }
export function formatChip_histPush(storage, key, doc, max = 8) {
    if (formatChip_isEmpty(doc)) return
    const sig = formatChip_sig(doc)
    const list = formatChip_histRead(storage, key).filter(h => h.sig !== sig)
    list.unshift({ sig, doc: formatChip_copy(doc) })
    try { storage.setItem(key, JSON.stringify(list.slice(0, max))) } catch (e) { /* хранилище недоступно */ }
}
// статистика правил грида Conditional format (метод cf_stats): записи _doc.cf_stats = [{id, rows, rows_pct, cells, fill}] → поля строки сводного грида;
// в режиме «All» строки вложенных источников (правила строк раскладки, полей, мер) цифр в самих правилах не несут — подмешиваются по row_id
export function cfStats_index(cf_stats) {
    const map = new Map()
    for (const s of Array.isArray(cf_stats) ? cf_stats : []) if (s && s.id) map.set(String(s.id), s)
    return map
}
export function cfStats_applyRow(row, stat) {   // true — строка изменилась
    if (!row || !stat) return false
    let changed = false
    const put = (k, v) => { if (row[k] !== v) { row[k] = v; changed = true } }
    put('_rows', stat.rows); put('_rows_pct', stat.rows_pct); put('_cells', stat.cells)
    const css = String(stat.fill || '').split(/\s+/).filter(Boolean)
    const sig = css.join(' '), cur = ((row._DLRow?.cells?._rows?.cssClasses) || []).join(' ')
    if (sig !== cur) {
        changed = true
        if (css.length) row._DLRow = { ...(row._DLRow || {}), cells: { ...(row._DLRow?.cells || {}), _rows: { cssClasses: css }, _cells: { cssClasses: [...css] } } }
        else if (row._DLRow?.cells) { const c = { ...row._DLRow.cells }; delete c._rows; delete c._cells; row._DLRow = { ...row._DLRow, cells: c } }
    }
    return changed
}
export const CF_STATS_KEYS = ['_rows', '_rows_pct', '_cells']
